import React from "react";

// Role icon map
const ROLE_ICONS = {
  buyer: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  ),
  supplier: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
  seller: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
  admin: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
  ),
  default: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
};

const SelectRoleStep = ({ accounts = [], loadingAction, onSelectRole }) => {
  return (
    <div className="flex flex-col pt-5 sm:pt-0 gap-4">
      <p className="text-xs text-gray-500 text-center bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 leading-relaxed">
        🔐 Multiple accounts found with this number. Please select your role to continue.
      </p>

      <div className="flex flex-col gap-3">
        {accounts.map((acc) => {
          const isLoading = loadingAction === `select-role-${acc.role}`;
          const icon = ROLE_ICONS[acc.role?.toLowerCase()] ?? ROLE_ICONS.default;

          return (
            <button
              key={acc.id}
              onClick={() => onSelectRole(acc.role)}
              disabled={loadingAction.startsWith("select-role-")}
              className="
                w-full border-2 border-gray-200 hover:border-primaryColor
                p-4 rounded-xl text-left transition-all duration-200
                disabled:opacity-60 disabled:cursor-not-allowed
                hover:bg-primaryColor/5 active:scale-[0.98]
                group relative overflow-hidden
              "
            >
              <div className="flex items-center gap-3">
                {/* Role icon circle */}
                <div className="w-10 h-10 rounded-xl bg-primaryColor/10 group-hover:bg-primaryColor/15 text-primaryColor flex items-center justify-center flex-shrink-0 transition-colors duration-200">
                  {isLoading ? (
                    <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                    </svg>
                  ) : icon}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm text-gray-800 truncate">{acc.fullName}</div>
                  <div className="text-xs text-gray-500 truncate">{acc.email}</div>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                  {/* Role badge */}
                  <span className="text-[10px] font-bold uppercase tracking-wider bg-primaryColor/10 text-primaryColor px-2 py-0.5 rounded-full">
                    {acc.role}
                  </span>
                  <svg className="w-4 h-4 text-gray-400 group-hover:text-primaryColor transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <p className="text-xs text-center text-gray-400 mt-1">
        If this is unexpected,{" "}
        <span className="text-primaryColor font-medium underline underline-offset-2 cursor-pointer">contact support</span>.
      </p>
    </div>
  );
};

export default SelectRoleStep;

















// /**
//  * SelectRoleStep.jsx
//  * ─────────────────────────────────────────────────────────────────────────────
//  * Shown when the verified phone number has multiple accounts.
//  * The user picks which role to log in as.
//  * ─────────────────────────────────────────────────────────────────────────────
//  */

// import React from "react";

// /**
//  * @param {{
//  *   accounts: Array<{ id: string|number, fullName: string, role: string, email: string }>,
//  *   loadingAction: string,
//  *   onSelectRole: (role: string) => void,
//  * }} props
//  */
// const SelectRoleStep = ({ accounts = [], loadingAction, onSelectRole }) => {
//   return (
//     <div className="space-y-4">
//       <p className="text-sm text-secondaryTextColor text-center">
//         Multiple accounts found with this number. Please select your role:
//       </p>

//       {accounts.map((acc) => (
//         <button
//           key={acc.id}
//           onClick={() => onSelectRole(acc.role)}
//           disabled={loadingAction.startsWith("select-role-")}
//           className="w-full border border-gray-300 hover:border-primaryColor p-4 rounded-lg text-left transition disabled:opacity-50"
//         >
//           <div className="font-medium">{acc.fullName}</div>
//           <div className="text-sm text-secondaryTextColor">
//             Role: <span className="capitalize">{acc.role}</span>
//           </div>
//           <div className="text-xs text-gray-500">{acc.email}</div>
//         </button>
//       ))}

//       <p className="text-xs text-center text-secondaryTextColor mt-4">
//         If this is unexpected, contact support.
//       </p>
//     </div>
//   );
// };

// export default SelectRoleStep;